// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3ce91ce0] .ant-select-disabled .ant-select-selection {\n  border: 0;\n  margin-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
